import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import ProcessSection from '../../components/ProcessSection/ProcessSection';
import FunFact from '../../components/FunFact/FunFact';
import TeamSection from '../../components/TeamSection/TeamSection';
import CtaSectionS2 from '../../components/CtaSectionS2/CtaSectionS2';
import BlogSection from '../../components/BlogSection/BlogSection';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Horizontal-Logo-white.png'


const AboutPage = () => {
    const SITE_URL = 'https://pharmacyfreedomfund.com';
    const schema = [
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
                { "@type": "ListItem", "position": 2, "name": "About Us", "item": `${SITE_URL}/about-us` }
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About Us",
            "url": `${SITE_URL}/about-us`,
            "mainEntity": {
                "@type": "Organization",
                "name": "Pharmacy Freedom Fund",
                "url": SITE_URL
            }
        }
    ];
    return (
        <Fragment>
            <SEO
                title="About Us"
                description="Pharmacy Freedom Fund is a mission-driven platform that acquires and supports independent pharmacies, aligning investor returns with community health."
                keywords={["about Pharmacy Freedom Fund", "pharmacy platform", "healthcare mission", "independent pharmacy"]}
                canonical="https://pharmacyfreedomfund.com/about-us"
                schema={schema}
            />
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={'About Us'} pagesub={'About Us'} />
            <About hclass={'about_section section-padding s4'} />
            <FunFact hclass={'funfact_section'} />
            <BlogSection tClass={'blog_section section-padding'} />
            <CtafromSection hclass={'ctafrom_section'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />

        </Fragment>
    )
};
export default AboutPage;
